export const SET_CONCEPTOSUBICAICON = "SET_CONCEPTOSUBICAICON";
export const REMOVE_CONCEPTOUBICACION = "REMOVE_CONCEPTOUBICACION";
export const CREATE_CONCEPTOSUBICACION = "CREATE_CONCEPTOSUBICACION";
export const CONCEPTOSUBICAICONS_RECEIVED = "CONCEPTOSUBICAICONS_RECEIVED";
export const SET_PROPERTY_CONCEPTOSUBICAICON =
  "SET_PROPERTY_CONCEPTOSUBICAICON";
